var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-block"},[_c('p',{staticClass:"title"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),(_vm.formatter)?_c('p',[_vm._v(_vm._s(_vm.formattedDescription))]):_c('p',[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }